const chapterNames = {
  1: 'Etat des lieux général',
  2: 'Les formulaires : une collecte de données à responsabiliser',
  3: 'La réglementation des cookies 2.0',
};

export default chapterNames;
